<div class="view-toggle">
  <button
    type="button"
    class="view-toggle__btn"
    [class.view-toggle__btn--active]="activeView() === 'list'"
    (click)="viewChange.emit('list')"
  >
    <ion-icon name="list-outline"></ion-icon>
  </button>
  <button
    type="button"
    class="view-toggle__btn"
    [class.view-toggle__btn--active]="activeView() === 'map'"
    (click)="viewChange.emit('map')"
  >
    <ion-icon name="map-outline"></ion-icon>
  </button>
</div>
